import { CreateControllerFn } from '@wix/yoshi-flow-editor';
import { createCategoryMenuController } from '../../external/category-menu-widget/controller';
import { createNoopController } from '../../external/common/controller/create-noop-controller';
import { editorAdapter } from '../../external/common/controller/editor-adapter';

const createController: CreateControllerFn = async ({
  appData,
  controllerConfig,
  flowAPI,
}) => {
  return editorAdapter({
    appData: appData || {},
    controllerConfig,
    flowAPI,
    createNoopController,
    createController: createCategoryMenuController,
  });
};

export default createController;
